import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { magazineIssueViewFragment } from '../fragments/MagazineIssueView.fragment'

import type {
    MagazineIssueViewQuery,
    MagazineIssueViewQueryVariables,
} from './View.queries.generated'

export const MAGAZINE_ISSUE_VIEW = gql`
    query MagazineIssueView($guid: String!) {
        entity(guid: $guid) {
            guid
            ...MagazineIssueView
        }
    }

    ${magazineIssueViewFragment}
` as TypedDocumentNode<MagazineIssueViewQuery, MagazineIssueViewQueryVariables>
